import {
  GridAlignment,
  GridRenderCellParams,
  GridColumnHeaderParams,
} from "@mui/x-data-grid-pro";
import {JunctionStatus, Operation, PriorityEnum} from "./Enum.types";
import {IObjectKeys, responseType} from "./formTypes";
import {itmType} from "../components/modules/asset/purchase/material/statesProvider/materialContext";
import Modal from "react-modal";
import {TicketStatus} from "./constants";
import {JSX} from "react";
export interface msgType {
  message: string;
  flag: boolean;
  operation: Operation;
}

export interface TableHeaderProps {
  headerName: string;
  className?: string;
  field: string;
  hideable?: boolean;
  headerAlign?: GridAlignment;
  align?: GridAlignment;
  disableColumnMenu?: boolean;
  disableColumnFilter?: boolean;
  cellClassName?: string;
  flex?: number;
  colSpan?: number;
  renderCell?: (params: GridRenderCellParams) => JSX.Element;
  renderHeader?: (params: GridColumnHeaderParams) => JSX.Element;
}

export interface LabelProps {
  labelName: string;
  inputName: string;
  dataType?: string;
  autoFocus?: boolean;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  formFields?: LabelProps[];
  className?: string;
  componentType?: string;
}

export interface TableHeaderJsonProps {
  labelName: string;
  className: string;
  type?: boolean;
}

export interface rfqFormData extends IObjectKeys {
  mrfNo: string;
  mrfDate: string;
  udfDesc: string;
  uom: string;
  presentStck: string;
  approxRate: string;
  approxQty: string;
  approxTaxable: string;
  tax: string;
  netValue: string;
  terms: string;
  paymentTerms: string;
  remark: string;
  taxedValue: string;
  subsidary: responseType | null;
  mrfId: number;
}

export interface rfqItems {
  mrfNo: responseType;
  mrfDate: string;
  subsidary: responseType;
  itm: itmType;
  udfDesc: string;
  uom: string;
  presentStck: number;
  approxRate: number;
  approxQty: number;
  approxTaxable: number;
  tax: number;
  netValue: string;
  suppliers: responseType[];
  terms: string;
  paymentTerms: string;
  remark: string;
}
export interface CustomModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  contentComponent: React.ReactNode;
  style: Modal.Styles;
}

export type ModifierKeys = "ctrlKey" | "shiftKey" | "altKey" | "metaKey";

export enum BrowserControlKeys {
  BACK = "back",
  FRONT = "front",
  // 🏠 Navigation & History Events
  POPSTATE = "popstate", // Detects back/forward button clicks
  HASHCHANGE = "hashchange", // Fires when the URL hash changes (e.g., #section)
  BEFOREUNLOAD = "beforeunload", // Warns user before leaving or refreshing the page
  UNLOAD = "unload", // Fires when the page is closing (not reliable for saving data)

  // 🌍 Page Lifecycle Events
  LOAD = "load", // Fires when the page and all assets are fully loaded
  DOMCONTENTLOADED = "DOMContentLoaded", // Fires when HTML is parsed but before images/styles load
  VISIBILITYCHANGE = "visibilitychange", // Detects when the user switches browser tabs
  PAGEHIDE = "pagehide", // Fires when the page is hidden or closed (better than unload)

  // 🎯 User Interaction Events
  CLICK = "click", // Detects mouse clicks anywhere on the page
  KEYDOWN = "keydown", // Fires when a key is pressed down
  KEYUP = "keyup", // Fires when a key is released
  MOUSEMOVE = "mousemove", // Detects mouse movement
  SCROLL = "scroll", // Fires when the user scrolls the page
  POINTERDOWN = "pointerdown", // Detects pointer (mouse, stylus, touch) press
  POINTERUP = "pointerup", // Detects pointer release

  // 📡 Network & Performance Events
  ONLINE = "online", // Fires when the device regains internet connection
  OFFLINE = "offline", // Fires when the device goes offline
  RESIZE = "resize", // Fires when the browser window is resized
}

export type Alphabet =
  | "a"
  | "b"
  | "c"
  | "d"
  | "e"
  | "f"
  | "g"
  | "h"
  | "i"
  | "j"
  | "k"
  | "l"
  | "m"
  | "n"
  | "o"
  | "p"
  | "q"
  | "r"
  | "s"
  | "t"
  | "u"
  | "v"
  | "w"
  | "x"
  | "y"
  | "z";

export interface TicketStatusOptionsTypes {
  label: string;
  value: TicketStatus;
}

export interface JunctionStatusOptionsTypes {
  label: string;
  value: JunctionStatus;
}

export interface PriorityOptionsTypes {
  label: string;
  value: PriorityEnum;
}

export interface AutocompleteProps {
  onKeyDown:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
  autoFocus?: boolean;
  label?: string;
  placeholder?: string;
}

export interface modalOpType {
  flag: boolean;
  operation: Operation;
  id?: number;
}

export interface opWithIdType {
  id: number;
  operation: Operation;
}
